import ManaWorld from "../loop/ManaWorld";
import ManaNode from "../mana/nodes/ManaNode";
import NodeRegistry from "../mana/nodes/NodeRegistry";
import CastingEntity from "../physics/CastingEntity";

export default class MGLoader {

	static version = "1"

	static loadManaWorld(json: any, manaWorld: ManaWorld) {
		const obj = json

		const nodes = obj.nodes

		const mappedNodes = nodes.map((node: any) => {
			const Klass = NodeRegistry.registeredNodes.find(rNode => rNode.type === node.type)?.create

			if (Klass) {

				const { connections, ...rest } = node

				const instance = Klass.load({ world: manaWorld, ...rest })

				return instance

			} else {
				throw new Error("File contains invalid node class! " + node.type)
			}
		})

		// establish connections
		nodes.forEach((node: any, index: number) => {

			const { connections } = node

			const mappedNode = mappedNodes[index]

			mappedNode.connections = connections.map((uuid: string) => {
				const foundNode = mappedNodes.find((fNode: ManaNode) => fNode.uuid === uuid)
				if (foundNode) {
					return foundNode
				} else {
					throw new Error("Broken connection to missing node uuid!")
				}
			})

		})

		mappedNodes.forEach((node: ManaNode) => {
			manaWorld.add(node)
		})
	}

	static loadMG(json: any, caster: CastingEntity) {

		const manaWorld = new ManaWorld(caster)

		MGLoader.loadManaWorld(json, manaWorld)

		caster.setManaWorld(manaWorld)

	}

	static saveMG(manaWorld: ManaWorld, pretty = false, object = false) {

		const nodes = manaWorld.getItems().filter(node => node instanceof ManaNode) as ManaNode[];

		const mappedNodes = nodes.map(node => {
			return ({
				...node.save(),

				uuid: node.uuid,
				connections: node.connections.map(connection => connection.uuid),
			})
		})

		const ret = {
			version: MGLoader.version,
			nodes: mappedNodes,
		}

		if (object) return ret

		return JSON.stringify(ret, undefined, pretty ? 4 : undefined)

	}

	static loadCasterFromFile(file: string, caster: CastingEntity) {
		return fetch(`/mana-graphs/${file}`).then(data => data.json()).then(json => {
			MGLoader.loadMG(json, caster)
		})
	}

}